import * as types from './types'
import to from '../../../helpers/to'
import { auth, db } from '../../../services/firebase'
import { functions } from '@/services/firebase'

const authFirebaseSdkCall = async (funcName, ...params) => {
  const [error, response] = await to(auth[funcName](...params))

  if (error) {
    console.error(error)
  }

  // Handle global error?
  return [error, response]
}

export default {
  [types.REGISTER_USER]: async function(store, payload) {
    const callable = functions.httpsCallable('registerUser')

    return await to(
      callable({
        email: payload.username,
        ...payload
      })
    )
  },
  [types.SIGNIN_USER]: async function(store, payload) {
    return await authFirebaseSdkCall(
      'signInWithEmailAndPassword',
      payload.username,
      payload.password
    )
  },
  [types.RESET_PASSWORD]: async function(store, email) {
    const callable = functions.httpsCallable('forgotPassword')

    return await to(
      callable({
        email
      })
    )
  },
  [types.UPDATE_USER_INFORMATIONS]: async function({ state, commit }, userPayload) {
    const userInformations = state.userInformations
    const userId = userInformations.userId

    const userDocumentReference = db.doc(`users/${userId}`)

    // Take old fields and update them
    const updatedUserInformations = Object.assign({}, userInformations, userPayload)

    try {
      await userDocumentReference.set(updatedUserInformations)

      commit(types.SET_USER_INFORMATIONS, updatedUserInformations)

      return [null, updatedUserInformations]
    } catch (error) {
      return [error, null]
    }
  },
  [types.VALIDATE_ACCOUNT]: async function(store, payload) {
    const callable = functions.httpsCallable('validateAccount')

    const [error, response] = await to(callable(payload))

    return [error, response]
  },
  [types.RESEND_CONFIRMATION_CODE]: async function(store) {
    const callable = functions.httpsCallable('resendConfirmationCode')

    return await to(
      callable({
        email: store.state.registeringUser.email
      })
    )
  },
  [types.CONFIRM_RESET_PASSWORD]: async function(store, payload) {
    const callable = functions.httpsCallable('updatePassword')

    return await to(callable(payload))
  },
  [types.LOAD_COMMANDS]: async function(store) {
    const userToken = await auth.currentUser.getIdToken(false)

    const callable = functions.httpsCallable('getUserCommands')

    const [error, response] = await to(
      callable({
        idToken: userToken
      })
    )

    const commands = response && response.data && response.data.commands ? response.data.commands : {}

    store.commit(types.SET_COMMANDS, commands)
  },
  [types.GET_COMMANDS]: async function() {
    const userToken = await auth.currentUser.getIdToken(false)

    const callable = functions.httpsCallable('getUserCommands')

    const [, response] = await to(
      callable({
        idToken: userToken
      })
    )

    const commands = response && response.data && response.data.commands ? response.data.commands : {}

    return commands
  },
  [types.SEND_GIFT_EMAIL]: async function(store, payload) {
    const callable = functions.httpsCallable('sendGiftEmail')

    return to(callable(payload))
  }
}
